import { ChangeEvent, useEffect, useMemo, useState } from 'react';
import { IconButton, InputAdornment, OutlinedInput } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { ReactComponent as SearchIcon } from '../assets/icons/main/search-icon.svg';
import debounce from 'lodash/debounce';
import {palette} from '../theme/palette';

const Styles = {
  outlinedInput: {
    gap: '0px', // This is correct (camelCase)
    '& .MuiOutlinedInput-input': {
      '&::placeholder': {
        fontStyle: 'italic',
        // If you want to add WebkitTextFillColor, use camelCase:
        // WebkitTextFillColor: 'yourColor',
      },
    },
  },
};

interface PropsTypes {
  searchPlaceholder: string;
  defaultValue?: string;
  onSearch: (value: string) => void;
  inputWidth?: SxProps<Theme>;
  width?: string;
  sx?: SxProps<Theme>;
}

const SearchField = ({ searchPlaceholder, defaultValue = '', onSearch, inputWidth, width, sx = {} }: PropsTypes) => {
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    setSearchValue(defaultValue);
  }, [defaultValue]);

  const handleChange = useMemo(
    () =>
      debounce((value: string) => {
        onSearch(value);
      }, 500),
    [onSearch]
  );

  const normalizedInputWidth = inputWidth || {};
  const normalizedWidth = width ? { width } : {};
  const mergedSx: SxProps<Theme> = [
    Styles.outlinedInput,
    normalizedInputWidth,
    normalizedWidth,
    ...(Array.isArray(sx) ? sx : [sx]),
  ];

  return (
    <OutlinedInput
      placeholder={searchPlaceholder}
      value={searchValue}
      onChange={(e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setSearchValue(e.target.value);
        handleChange(e.target.value);
      }}
      endAdornment={
        <InputAdornment position='end' sx={{ marginLeft: '0px' }}>
          <IconButton onClick={() => onSearch(searchValue)} edge='end'>
            <SearchIcon style={{color: palette.info.dark, opacity:'0.7'}} />
          </IconButton>
        </InputAdornment>
      }
      sx={mergedSx}
    />
  );
};

export default SearchField;
